import { render } from "./VimeoPlayer.vue?vue&type=template&id=4d7965b0&scoped=true"
import script from "./VimeoPlayer.vue?vue&type=script&lang=js"
export * from "./VimeoPlayer.vue?vue&type=script&lang=js"

import "./VimeoPlayer.vue?vue&type=style&index=0&id=4d7965b0&scoped=true&lang=css"

import exportComponent from "/Users/matalem/system/radioaconcagua/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d7965b0"]])

export default __exports__